import { useEffect, useState } from "react";
import { getHorse } from "@/lib/api";
import { fmtD } from "@/lib/pipelineApi";
import { PublishingTab } from "@/components/PublishingTab";
import { FacebookGroupPost } from "./FacebookGroupPost";
import { FacebookPagePost } from "./FacebookPagePost";
import { GroupDistribution } from "./GroupDistribution";
import { GroupAutoPublish } from "./GroupAutoPublish";
import { closeShort } from "@/lib/brand";

// Workspace Publishing tab: the SAME Ad Builder PublishingTab (statuses, links, dates, history, controls) on the same horse record,
// plus the existing Facebook Group Post / Mark as Posted controls. No separate publishing logic.
export function WorkspacePublishing({ c, hid, onLeave, onChanged, className }) {
  const [horse, setHorse] = useState(null);
  useEffect(() => { getHorse(hid).then(setHorse).catch(() => setHorse(false)); }, [hid, c.listing_status, c.stage, c.website_hidden, c.facebook_group_status]);
  const d = c.dates || {};
  const web = c.website_hidden ? "Hidden" : c.stage === "completed" ? "Completed" : { published: "Published", scheduled: "Scheduled" }[c.listing_status] || "Not Published";
  return (
    <div data-testid="workspace-publishing" className="space-y-3">
      <section className="rounded-xl border border-stone-200 bg-white p-4 text-sm space-y-1">
        <p data-testid="workspace-publishing-website-status"><span className="text-stone-500">Website</span> <span className="font-semibold">{web}</span></p>
        <p><span className="text-stone-500">Bidding Starts</span> <span className="font-semibold">{d.bidding_starts ? `${fmtD(d.bidding_starts)}${d.bidding_starts_time ? ` · ${closeShort(d.bidding_starts_time)}` : ""}` : "—"}</span></p>
        <p><span className="text-stone-500">Bidding Ends</span> <span className="font-semibold">{d.close_date ? `${fmtD(d.close_date)} · ${closeShort(d.close_time)}` : "—"}</span></p>
      </section>
      <FacebookGroupPost c={c} hid={hid} onLeave={onLeave} onDone={onChanged} className={className} />
      <GroupAutoPublish hid={hid} posted={c.facebook_group_status === "published"} onChanged={onChanged} />
      <FacebookPagePost hid={hid} onChanged={onChanged} />
      <GroupDistribution hid={hid} />
      {horse === null ? <p className="text-sm text-stone-500">Loading publishing…</p> : horse === false ? <p className="text-sm text-red-700">Could not load publishing details.</p>
        : <PublishingTab horse={horse} onChange={(h) => { setHorse((cur) => ({ ...cur, publishing: h.publishing, publishing_destinations: h.publishing_destinations })); onChanged?.(); }} />}
    </div>
  );
}
